// extracted by mini-css-extract-plugin
export default {"SavedPage":"SavedPage_SavedPage__FllsJ"};